var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 97,
    viewBox: "0 0 182 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2217_1998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.492 71.5398H119.63C118.846 71.5398 118.208 70.8982 118.208 70.1102V5.88268C118.208 5.09472 118.846 4.45312 119.63 4.45312H163.492C164.276 4.45312 164.914 5.09472 164.914 5.88268V70.1078C164.914 70.8958 164.276 71.5374 163.492 71.5374V71.5398ZM119.632 4.51411C118.882 4.51411 118.271 5.12887 118.271 5.88268V70.1078C118.271 70.8616 118.882 71.4764 119.632 71.4764H163.494C164.244 71.4764 164.856 70.8616 164.856 70.1078V5.88268C164.856 5.12887 164.244 4.51411 163.494 4.51411H119.632Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.915 71.5398H69.0532C68.2694 71.5398 67.6312 70.8982 67.6312 70.1102V5.88268C67.6312 5.09472 68.2694 4.45312 69.0532 4.45312H112.915C113.699 4.45312 114.337 5.09472 114.337 5.88268V70.1078C114.337 70.8958 113.699 71.5374 112.915 71.5374V71.5398ZM69.0532 4.51411C68.3034 4.51411 67.6919 5.12887 67.6919 5.88268V70.1078C67.6919 70.8616 68.3034 71.4764 69.0532 71.4764H112.915C113.665 71.4764 114.277 70.8616 114.277 70.1078V5.88268C114.277 5.12887 113.665 4.51411 112.915 4.51411H69.0532Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3678 71.5398H18.5082C17.7244 71.5398 17.0862 70.8982 17.0862 70.1102V5.88268C17.0862 5.09472 17.7244 4.45312 18.5082 4.45312H62.3702C63.154 4.45312 63.7922 5.09472 63.7922 5.88268V70.1078C63.7922 70.8958 63.154 71.5374 62.3702 71.5374L62.3678 71.5398ZM18.5082 4.51411C17.7584 4.51411 17.1468 5.12887 17.1468 5.88268V70.1078C17.1468 70.8616 17.7584 71.4764 18.5082 71.4764H62.3702C63.12 71.4764 63.7316 70.8616 63.7316 70.1078V5.88268C63.7316 5.12887 63.12 4.51411 62.3702 4.51411H18.5082Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 86.4375H0V86.4668H182V86.4375Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.138 93.6016H158.614V93.704H172.138V93.6016Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.68 94.7109H120.13V94.8134H123.68V94.7109Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4965 90.4766H9.86194V90.579H27.4965V90.4766Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.721 90.4766H31.1342V90.579H33.721V90.4766Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3712 92.2109H42.1245V92.3134H80.3712V92.2109Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.846 20.2343C117.266 19.7952 116.422 19.744 115.793 20.1124C114.961 18.4218 112.643 17.6753 110.989 18.5657C110.557 16.7434 108.773 15.3431 106.909 15.3675C105.046 15.3895 103.296 16.8337 102.908 18.6633C102.847 18.9536 102.806 19.2732 102.597 19.4854C102.26 19.8318 101.699 19.7147 101.219 19.6781C99.7094 19.561 98.1927 20.6247 97.7826 22.0884L118.555 22.0127C118.737 21.3053 118.424 20.6734 117.844 20.2319L117.846 20.2343Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.029 14.9224C169.221 14.3076 168.039 14.2393 167.166 14.754C166.006 12.395 162.769 11.3534 160.461 12.5975C159.859 10.0555 157.367 8.10148 154.768 8.13319C152.169 8.16491 149.725 10.1775 149.184 12.7341C149.099 13.1391 149.041 13.5855 148.752 13.8807C148.284 14.3637 147.5 14.2003 146.83 14.149C144.726 13.9832 142.608 15.4688 142.035 17.5131L171.019 17.4082C171.274 16.4227 170.837 15.5396 170.027 14.9248L170.029 14.9224Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8485 34.9453C38.2685 34.5062 37.424 34.4549 36.7955 34.8233C35.9632 33.1327 33.6457 32.3862 31.9907 33.2766C31.5588 31.4543 29.7752 30.054 27.9115 30.0784C26.0478 30.1004 24.2982 31.5446 23.9099 33.3742C23.8492 33.6645 23.808 33.9841 23.5993 34.1963C23.262 34.5428 22.7014 34.4257 22.2209 34.3891C20.7116 34.272 19.1949 35.3356 18.7848 36.7993L39.5571 36.7237C39.7391 36.0162 39.426 35.3844 38.846 34.9428L38.8485 34.9453Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5955 24.3394C64.2849 24.1028 63.8311 24.076 63.4938 24.2736C63.0473 23.3661 61.8024 22.966 60.9142 23.4441C60.6837 22.4659 59.7252 21.7145 58.7254 21.7267C57.7256 21.7389 56.7865 22.5122 56.5778 23.4954C56.5438 23.6515 56.522 23.8223 56.4128 23.9369C56.2332 24.1223 55.9299 24.0589 55.6726 24.0394C54.8621 23.9759 54.0492 24.5468 53.8284 25.3323L64.9765 25.2908C65.0735 24.9103 64.9061 24.5712 64.5955 24.337V24.3394Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1132 7.0238C71.6861 6.69934 71.0625 6.66275 70.6014 6.93353C69.9875 5.68694 68.2791 5.13805 67.0609 5.79428C66.743 4.45255 65.4278 3.42063 64.0543 3.43771C62.6808 3.45479 61.3922 4.51841 61.1059 5.86747C61.0598 6.08214 61.0306 6.31634 60.8778 6.47247C60.6302 6.72618 60.2153 6.64079 59.8634 6.61396C58.752 6.52613 57.6333 7.31166 57.3324 8.38992L72.6374 8.33382C72.7708 7.81176 72.5403 7.34581 72.1132 7.0238Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.605 30.1441C167.294 29.9075 166.841 29.8806 166.503 30.0782C166.057 29.1707 164.812 28.7707 163.924 29.2488C163.693 28.2706 162.735 27.5192 161.735 27.5314C160.735 27.5436 159.796 28.3169 159.587 29.3C159.553 29.4562 159.531 29.6269 159.422 29.7416C159.243 29.927 158.939 29.8636 158.682 29.8441C157.872 29.7806 157.059 30.3515 156.838 31.137L167.986 31.0955C168.083 30.715 167.916 30.3759 167.605 30.1417V30.1441Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1096 14.6328C43.5296 14.1937 42.6851 14.1424 42.0566 14.5108C41.2243 12.8202 38.9068 12.0737 37.2518 12.9641C36.8199 11.1418 35.0363 9.74154 33.1726 9.76594C31.3089 9.78789 29.5593 11.2321 29.171 13.0617C29.1104 13.352 29.0691 13.6716 28.8604 13.8838C28.5231 14.2303 27.9625 14.1132 27.4821 14.0766C25.9727 13.9595 24.456 15.0231 24.0459 16.4868L44.8182 16.4112C45.0002 15.7037 44.6871 15.0719 44.1072 14.6303L44.1096 14.6328Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.955 51.7787L152.667 35.9438H143.838V39.5543H137.337V0H124.84V15.569H121.088V7.79425H111.336V45.7068H97.5836V32.3114H88.9617V3.26895H78.3207V22.6314H68.318V64.3422H60.5697V44.0308H52.5689V30.9623H44.0683V20.9262L34.5849 25.9564V52.8033H24.5822V47.2656H11.2234V86.1759L166.734 86.2515V51.7787H152.955Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2193 86.1968V28.3047H42.5929V86.2529C45.9563 86.17 53.2193 86.1968 53.2193 86.1968Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5417 86.2546V54.4141H21.675V86.1839L43.5442 86.2546H43.5417Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1137 86.202V39.4609H57.7256V86.1972L70.1137 86.202Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 41.2969H58.6647V44.4121H60.1668V41.2969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 41.2969H61.6689V44.4121H63.1711V41.2969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 41.2969H64.6708V44.4121H66.1729V41.2969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 41.2969H67.6749V44.4121H69.177V41.2969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 46.5156H58.6647V49.6309H60.1668V46.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 46.5156H61.6689V49.6309H63.1711V46.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 46.5156H64.6708V49.6309H66.1729V46.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 46.5156H67.6749V49.6309H69.177V46.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 51.7344H58.6647V54.8496H60.1668V51.7344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 51.7344H61.6689V54.8496H63.1711V51.7344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 51.7344H64.6708V54.8496H66.1729V51.7344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 51.7344H67.6749V54.8496H69.177V51.7344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 56.9609H58.6647V60.0762H60.1668V56.9609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 56.9609H61.6689V60.0762H63.1711V56.9609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 56.9609H64.6708V60.0762H66.1729V56.9609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 56.9609H67.6749V60.0762H69.177V56.9609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 62.1797H58.6647V65.2949H60.1668V62.1797Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 62.1797H61.6689V65.2949H63.1711V62.1797Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 62.1797H64.6708V65.2949H66.1729V62.1797Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 62.1797H67.6749V65.2949H69.177V62.1797Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 67.3984H58.6647V70.5137H60.1668V67.3984Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 67.3984H61.6689V70.5137H63.1711V67.3984Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 67.3984H64.6708V70.5137H66.1729V67.3984Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 67.3984H67.6749V70.5137H69.177V67.3984Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 72.6172H58.6647V75.7324H60.1668V72.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 72.6172H61.6689V75.7324H63.1711V72.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 72.6172H64.6708V75.7324H66.1729V72.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 72.6172H67.6749V75.7324H69.177V72.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 77.8438H58.6647V80.959H60.1668V77.8438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1711 77.8438H61.6689V80.959H63.1711V77.8438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1729 77.8438H64.6708V80.959H66.1729V77.8438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.177 77.8438H67.6749V80.959H69.177V77.8438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.163 86.2252V32.8047H87.4766V86.2423C87.4766 86.2423 112.966 86.2496 113.163 86.2252Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 34.9375H89.4058V38.5236H92.5192V34.9375Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 34.9375H95.6375V38.5236H98.7509V34.9375Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 34.9375H101.864V38.5236H104.978V34.9375Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 34.9375H108.096V38.5236H111.209V34.9375Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 40.9531H89.4058V44.5392H92.5192V40.9531Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 40.9531H95.6375V44.5392H98.7509V40.9531Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 40.9531H101.864V44.5392H104.978V40.9531Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 40.9531H108.096V44.5392H111.209V40.9531Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 46.9688H89.4058V50.5548H92.5192V46.9688Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 46.9688H95.6375V50.5548H98.7509V46.9688Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 46.9688H101.864V50.5548H104.978V46.9688Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 46.9688H108.096V50.5548H111.209V46.9688Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 52.9844H89.4058V56.5705H92.5192V52.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 52.9844H95.6375V56.5705H98.7509V52.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 52.9844H101.864V56.5705H104.978V52.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 52.9844H108.096V56.5705H111.209V52.9844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 59H89.4058V62.5861H92.5192V59Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 59H95.6375V62.5861H98.7509V59Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 59H101.864V62.5861H104.978V59Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 59H108.096V62.5861H111.209V59Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 65.0156H89.4058V68.6017H92.5192V65.0156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 65.0156H95.6375V68.6017H98.7509V65.0156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 65.0156H101.864V68.6017H104.978V65.0156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 65.0156H108.096V68.6017H111.209V65.0156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 71.0312H89.4058V74.6173H92.5192V71.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 71.0312H95.6375V74.6173H98.7509V71.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 71.0312H101.864V74.6173H104.978V71.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 71.0312H108.096V74.6173H111.209V71.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5192 77.0469H89.4058V80.633H92.5192V77.0469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 77.0469H95.6375V80.633H98.7509V77.0469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.978 77.0469H101.864V80.633H104.978V77.0469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.209 77.0469H108.096V80.633H111.209V77.0469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 32.2344H44.5537V35.5399H47.422V32.2344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 37.7812H44.5537V41.0868H47.422V37.7812Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 43.3281H44.5537V46.6337H47.422V43.3281Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 48.8672H44.5537V52.1727H47.422V48.8672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 54.4141H44.5537V57.7196H47.422V54.4141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 59.9609H44.5537V63.2665H47.422V59.9609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 65.5H44.5537V68.8055H47.422V65.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 71.0469H44.5537V74.3524H47.422V71.0469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 32.2344H48.3927V35.5399H51.261V32.2344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 37.7812H48.3927V41.0868H51.261V37.7812Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 43.3281H48.3927V46.6337H51.261V43.3281Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 48.8672H48.3927V52.1727H51.261V48.8672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 54.4141H48.3927V57.7196H51.261V54.4141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 59.9609H48.3927V63.2665H51.261V59.9609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 65.5H48.3927V68.8055H51.261V65.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.261 71.0469H48.3927V74.3524H51.261V71.0469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 7.10938H80.7546V10.6955H83.868V7.10938Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 13.125H80.7546V16.7111H83.868V13.125Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 18.7344H80.7546V22.3205H83.868V18.7344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 24.7422H80.7546V28.3283H83.868V24.7422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 30.7578H80.7546V34.3439H83.868V30.7578Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 36.7812H80.7546V40.3673H83.868V36.7812Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 42.7891H80.7546V46.3751H83.868V42.7891Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.868 48.8125H80.7546V52.3986H83.868V48.8125Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 1.89844H127.531V5.48452H130.645V1.89844Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 7.90625H127.531V11.4923H130.645V7.90625Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 13.9297H127.531V17.5158H130.645V13.9297Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 19.9453H127.531V23.5314H130.645V19.9453Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 25.9609H127.531V29.547H130.645V25.9609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 31.9766H127.531V35.5626H130.645V31.9766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 37.9922H127.531V41.5783H130.645V37.9922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 44.0078H127.531V47.5939H130.645V44.0078Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.953 29.5312H134.2V86.25H152.953V29.5312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 32.3281H136.973V35.9142H142.47V32.3281Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 38.3438H136.973V41.9298H142.47V38.3438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 44.3594H136.973V47.9455H142.47V44.3594Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 50.375H136.973V53.9611H142.47V50.375Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 56.3906H136.973V59.9767H142.47V56.3906Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 62.4062H136.973V65.9923H142.47V62.4062Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 68.4297H136.973V72.0158H142.47V68.4297Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47 74.4453H136.973V78.0314H142.47V74.4453Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 32.3281H144.328V35.9142H149.825V32.3281Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 38.3438H144.328V41.9298H149.825V38.3438Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 44.3594H144.328V47.9455H149.825V44.3594Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 50.375H144.328V53.9611H149.825V50.375Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 56.3906H144.328V59.9767H149.825V56.3906Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 62.4062H144.328V65.9923H149.825V62.4062Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 68.4297H144.328V72.0158H149.825V68.4297Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.825 74.4453H144.328V78.0314H149.825V74.4453Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.974 86.2303V46.9688H115.793V86.2279L123.974 86.2327V86.2303Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 48.5547H116.415V51.2284H117.407V48.5547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 48.5547H118.397V51.2284H119.39V48.5547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 48.5547H120.377V51.2284H121.37V48.5547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 48.5547H122.362V51.2284H123.355V48.5547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 53.0391H116.415V55.7128H117.407V53.0391Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 53.0391H118.397V55.7128H119.39V53.0391Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 53.0391H120.377V55.7128H121.37V53.0391Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 53.0391H122.362V55.7128H123.355V53.0391Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 57.5234H116.415V60.1971H117.407V57.5234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 57.5234H118.397V60.1971H119.39V57.5234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 57.5234H120.377V60.1971H121.37V57.5234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 57.5234H122.362V60.1971H123.355V57.5234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 62.0078H116.415V64.6815H117.407V62.0078Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 62.0078H118.397V64.6815H119.39V62.0078Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 62.0078H120.377V64.6815H121.37V62.0078Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 62.0078H122.362V64.6815H123.355V62.0078Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 66.5H116.415V69.1737H117.407V66.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 66.5H118.397V69.1737H119.39V66.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 66.5H120.377V69.1737H121.37V66.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 66.5H122.362V69.1737H123.355V66.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 70.9844H116.415V73.6581H117.407V70.9844Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 70.9844H118.397V73.6581H119.39V70.9844Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 70.9844H120.377V73.6581H121.37V70.9844Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 70.9844H122.362V73.6581H123.355V70.9844Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 75.4688H116.415V78.1425H117.407V75.4688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 75.4688H118.397V78.1425H119.39V75.4688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 75.4688H120.377V78.1425H121.37V75.4688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 75.4688H122.362V78.1425H123.355V75.4688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.407 79.9531H116.415V82.6268H117.407V79.9531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 79.9531H118.397V82.6268H119.39V79.9531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37 79.9531H120.377V82.6268H121.37V79.9531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.355 79.9531H122.362V82.6268H123.355V79.9531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 55.7422H23.3301V57.9865H25.9824V55.7422Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 55.7422H28.6323V57.9865H31.2847V55.7422Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5845 55.7422H33.9321V57.9865H36.5845V55.7422Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8867 55.7422H39.2344V57.9865H41.8867V55.7422Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 59.5078H23.3301V61.7522H25.9824V59.5078Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 59.5078H28.6323V61.7522H31.2847V59.5078Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5845 59.5078H33.9321V61.7522H36.5845V59.5078Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8867 59.5078H39.2344V61.7522H41.8867V59.5078Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 63.2656H23.3301V65.51H25.9824V63.2656Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 63.2656H28.6323V65.51H31.2847V63.2656Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5845 63.2656H33.9321V65.51H36.5845V63.2656Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8867 63.2656H39.2344V65.51H41.8867V63.2656Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 67.0312H23.3301V69.2756H25.9824V67.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 67.0312H28.6323V69.2756H31.2847V67.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5845 67.0312H33.9321V69.2756H36.5845V67.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8867 67.0312H39.2344V69.2756H41.8867V67.0312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 70.7891H23.3301V73.0334H25.9824V70.7891Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 70.7891H28.6323V73.0334H31.2847V70.7891Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5845 70.7891H33.9321V73.0334H36.5845V70.7891Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8867 70.7891H39.2344V73.0334H41.8867V70.7891Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 74.5469H23.3301V76.7912H25.9824V74.5469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 74.5469H28.6323V76.7912H31.2847V74.5469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5845 74.5469H33.9321V76.7912H36.5845V74.5469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8867 74.5469H39.2344V76.7912H41.8867V74.5469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 78.3125H23.3301V80.5568H25.9824V78.3125Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 78.3125H28.6323V80.5568H31.2847V78.3125Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5845 78.3125H33.9321V80.5568H36.5845V78.3125Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8867 78.3125H39.2344V80.5568H41.8867V78.3125Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6093 96.9982C127.035 96.9982 156.564 96.4827 156.564 95.8468C156.564 95.2108 127.035 94.6953 90.6093 94.6953C54.1837 94.6953 24.6549 95.2108 24.6549 95.8468C24.6549 96.4827 54.1837 96.9982 90.6093 96.9982Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0547 53.6875C100.258 55.7172 105.871 59.8595 112.129 64.7897L105.975 64.7605L95.9431 54.9536L96.0547 53.6875Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0807 81.9003L30.1465 83.5446L24.5967 84.5179L25.4169 85.9475L36.2228 85.2205L63.5665 86.0792L124.486 86.9599L147.959 86.9794L159.922 86.2427V84.2106L150.189 71.5665L142.205 69.3685L129.409 70.2858L71.6619 71.0176C71.6619 71.0176 56.568 68.1585 56.2404 68.0488C55.9128 67.939 43.9906 66.0703 43.9906 66.0703L26.0527 70.2858L31.0832 81.9028L31.0807 81.9003Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.0807 81.9003L30.1465 83.5446L24.5967 84.5179L25.4169 85.9475L36.2228 85.2205L63.5665 86.0792L124.486 86.9599L147.959 86.9794L159.922 86.2427V84.2106L150.189 71.5665L142.205 69.3685L129.409 70.2858L71.6619 71.0176C71.6619 71.0176 56.568 68.1585 56.2404 68.0488C55.9128 67.939 43.9906 66.0703 43.9906 66.0703L26.0527 70.2858L31.0832 81.9028L31.0807 81.9003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9359 67.0093C17.3241 67.0093 39.8048 61.4326 39.8048 61.4326L55.765 54.8776C55.765 54.8776 65.9837 52.2356 79.8982 52.5308C89.1098 52.726 93.3322 53.0919 95.1328 53.3163C95.754 53.3944 96.2927 53.7628 96.6228 54.297C96.7538 54.5093 96.9431 54.7679 97.2197 55.0728C98.1928 56.1486 105.978 64.7577 105.978 64.7577H112.692C112.692 64.7577 145.098 67.0069 154.732 68.1828C154.732 68.1828 160.764 68.9658 162.711 70.0417L164.657 77.9652H166.506C166.506 77.9652 166.312 86.867 152.007 85.4984C152.007 85.4984 151.325 79.3362 150.06 77.0845C148.796 74.8329 145.877 72.0957 139.648 72.0957C133.418 72.0957 128.555 74.7377 127.191 79.041C125.83 83.3443 125.051 88.0502 125.051 88.0502L62.3825 87.6476C62.3825 87.6476 62.4795 81.3878 61.4094 78.6483C60.3392 75.9087 58.4901 70.6271 48.565 71.115C38.64 71.6054 36.6938 76.299 35.0388 83.5395C35.0388 83.5395 21.7067 82.2685 20.7336 81.2903C19.7605 80.312 19.4693 79.2362 19.4693 79.2362H15.5769C14.8247 79.2362 14.2156 78.6239 14.2156 77.8676V77.0845C14.2156 76.3283 14.8247 75.716 15.5769 75.716L16.9383 67.0093H16.9359Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7731 68.1328L157.816 68.7037C159.512 68.9842 161.354 69.3721 162.708 70.0429L163.106 71.6652L16.3218 71.0163L16.7731 68.1352V68.1328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.715 64.4175L72.4845 64.6468L66.7528 59.375L57.1553 59.736L39.8046 61.434L27.715 64.4175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8047 61.43H54.7699C55.9954 61.43 56.9102 60.2932 56.6554 59.088L55.7624 54.875C52.3214 55.8972 46.0606 58.6636 39.8022 61.43H39.8047Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6337 55.9764C66.5514 56.0984 65.8234 57.1498 66.0855 58.2135L67.1993 62.7363C67.1993 62.7363 67.6191 64.5611 71.4557 64.6294C75.0787 64.6952 101.158 64.888 104.056 64.9075C104.16 64.9075 104.218 64.7855 104.153 64.705C103.099 63.4072 97.2997 56.3497 94.8293 55.3007C90.7525 53.5686 73.5863 55.3056 67.6361 55.974L67.6337 55.9764Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94.5794 55.8906C93.8344 55.5686 92.0605 55.1953 87.86 55.1953C81.0313 55.1953 71.4897 56.1858 67.7041 56.6102C67.3643 56.6493 67.0707 56.8249 66.8766 57.1055C66.6849 57.3836 66.6193 57.7324 66.7018 58.0617L67.374 60.3695H99.5807C96.1834 57.0103 95.9432 56.4809 94.5794 55.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.606 72.8203H57.1504C59.861 74.4987 60.771 77.0212 61.4068 78.6483C62.4769 81.3879 62.3799 87.6477 62.3799 87.6477L125.049 88.0502C125.049 88.0502 125.827 83.3444 127.189 79.0411C128.13 76.0649 130.749 73.8839 134.331 72.8228H71.606V72.8203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.503 77.9628H164.654L163.39 72.8203H144.632C147.561 73.7864 149.194 75.5477 150.058 77.0821C151.322 79.3314 152.004 85.496 152.004 85.496C166.309 86.8646 166.503 77.9628 166.503 77.9628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.731 81.2903C21.7041 82.2686 35.0362 83.5395 35.0362 83.5395C36.1622 78.6142 37.4265 74.8671 41.2436 72.8203H16.0257L15.5719 75.7136C14.8197 75.7136 14.2106 76.3259 14.2106 77.0821V77.8652C14.2106 78.6215 14.8197 79.2338 15.5719 79.2338H19.4643C19.4643 79.2338 19.7555 80.3096 20.7286 81.2879L20.731 81.2903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0381 96.1944C55.6172 96.1944 60.9506 90.8447 60.9506 84.2456C60.9506 77.6465 55.6172 72.2969 49.0381 72.2969C42.459 72.2969 37.1256 77.6465 37.1256 84.2456C37.1256 90.8447 42.459 96.1944 49.0381 96.1944Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.0382 91.5736C53.0709 91.5736 56.34 88.2937 56.34 84.2477C56.34 80.2018 53.0709 76.9219 49.0382 76.9219C45.0055 76.9219 41.7363 80.2018 41.7363 84.2477C41.7363 88.2937 45.0055 91.5736 49.0382 91.5736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0381 77.6562H49.0332C48.7116 77.6562 48.4508 77.9184 48.4508 78.2417V81.9961C48.4508 82.3195 48.7116 82.5816 49.0332 82.5816H49.0381C49.3597 82.5816 49.6205 82.3195 49.6205 81.9961V78.2417C49.6205 77.9184 49.3597 77.6562 49.0381 77.6562Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0381 85.9062H49.0332C48.7116 85.9062 48.4508 86.1684 48.4508 86.4917V90.2461C48.4508 90.5695 48.7116 90.8316 49.0332 90.8316H49.0381C49.3597 90.8316 49.6205 90.5695 49.6205 90.2461V86.4917C49.6205 86.1684 49.3597 85.9062 49.0381 85.9062Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2658 83.6315C50.9867 83.7901 50.6349 83.6901 50.4771 83.412C50.3145 83.1339 50.4092 82.7753 50.6882 82.6118L53.9303 80.7261C54.2093 80.5651 54.5661 80.6626 54.7262 80.9432C54.8864 81.2237 54.7893 81.5799 54.5102 81.7409L51.2706 83.6267C51.2706 83.6267 51.2658 83.6291 51.2634 83.6315H51.2658Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3452 87.5212C43.185 87.2407 43.2821 86.8845 43.5611 86.7235L46.8008 84.8378C47.0798 84.6743 47.439 84.7695 47.6016 85.05C47.7641 85.3306 47.6671 85.6916 47.388 85.8526L44.1484 87.7384C43.8669 87.9018 43.5102 87.8042 43.3476 87.5237L43.3452 87.5212Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7262 87.5377C54.5661 87.8182 54.2093 87.9134 53.9303 87.7524L50.6882 85.8666C50.4092 85.7032 50.3145 85.3421 50.4771 85.064C50.6397 84.7859 50.9964 84.6908 51.2755 84.8518L54.5151 86.7375C54.7942 86.8985 54.8888 87.2571 54.7286 87.5377H54.7262Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5991 83.4186C47.4366 83.6967 47.0798 83.7918 46.8008 83.6284L43.5612 81.7426C43.2821 81.5816 43.1875 81.223 43.3476 80.9425C43.5102 80.6619 43.8694 80.5643 44.1484 80.7278L47.388 82.6135C47.6671 82.7745 47.7617 83.1331 47.6016 83.4137C47.6016 83.4137 47.6016 83.4186 47.5991 83.4186Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.0381 83.2578C49.5792 83.2578 50.0209 83.6994 50.0209 84.2434C50.0209 84.7874 49.5817 85.2289 49.0381 85.2289C48.4945 85.2289 48.0553 84.7874 48.0553 84.2434C48.0553 83.6994 48.4945 83.2578 49.0381 83.2578Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.757 96.1944C145.336 96.1944 150.669 90.8447 150.669 84.2456C150.669 77.6465 145.336 72.2969 138.757 72.2969C132.178 72.2969 126.844 77.6465 126.844 84.2456C126.844 90.8447 132.178 96.1944 138.757 96.1944Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.757 91.5736C142.79 91.5736 146.059 88.2937 146.059 84.2477C146.059 80.2018 142.79 76.9219 138.757 76.9219C134.724 76.9219 131.455 80.2018 131.455 84.2477C131.455 88.2937 134.724 91.5736 138.757 91.5736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.339 78.2417V81.9961C139.339 82.3182 139.077 82.5816 138.757 82.5816H138.752C138.429 82.5816 138.17 82.3206 138.17 81.9961V78.2417C138.17 77.9197 138.432 77.6562 138.752 77.6562H138.757C139.08 77.6562 139.339 77.9173 139.339 78.2417Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.339 86.4917V90.2461C139.339 90.5682 139.077 90.8316 138.757 90.8316H138.752C138.429 90.8316 138.17 90.5706 138.17 90.2461V86.4917C138.17 86.1697 138.432 85.9062 138.752 85.9062H138.757C139.08 85.9062 139.339 86.1673 139.339 86.4917Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.985 83.6315C140.705 83.7901 140.354 83.6901 140.196 83.412C140.033 83.1339 140.128 82.7753 140.407 82.6118L143.649 80.7261C143.928 80.5651 144.285 80.6626 144.445 80.9432C144.605 81.2237 144.508 81.5799 144.229 81.7409L140.989 83.6267C140.989 83.6267 140.985 83.6291 140.982 83.6315H140.985Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.064 87.5212C132.904 87.2407 133.001 86.8845 133.28 86.7235L136.52 84.8378C136.799 84.6743 137.158 84.7695 137.32 85.05C137.483 85.3306 137.386 85.6916 137.107 85.8526L133.867 87.7384C133.586 87.9018 133.229 87.8042 133.066 87.5237L133.064 87.5212Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.445 87.5377C144.285 87.8182 143.928 87.9134 143.649 87.7524L140.407 85.8666C140.128 85.7032 140.033 85.3421 140.196 85.064C140.358 84.7859 140.715 84.6908 140.994 84.8518L144.234 86.7375C144.513 86.8985 144.608 87.2571 144.447 87.5377H144.445Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.315 83.4186C137.153 83.6967 136.796 83.7918 136.517 83.6284L133.277 81.7426C132.998 81.5816 132.904 81.223 133.064 80.9425C133.227 80.6619 133.586 80.5643 133.865 80.7278L137.104 82.6135C137.383 82.7745 137.478 83.1331 137.318 83.4137C137.318 83.4137 137.318 83.4186 137.315 83.4186Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.757 83.2578C139.298 83.2578 139.74 83.6994 139.74 84.2434C139.74 84.7874 139.3 85.2289 138.757 85.2289C138.213 85.2289 137.774 84.7874 137.774 84.2434C137.774 83.6994 138.213 83.2578 138.757 83.2578Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3164 61.5783C98.3164 61.5783 97.3166 62.9541 97.7753 65.3351C97.7753 65.3351 101.855 65.9377 102.483 64.3886C103.112 62.8395 99.9156 61.2343 98.3164 61.5783Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.3164 61.5783C98.3164 61.5783 97.3166 62.9541 97.7753 65.3351C97.7753 65.3351 101.855 65.9377 102.483 64.3886C103.112 62.8395 99.9156 61.2343 98.3164 61.5783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.386 72.5547L56.8593 72.6572C58.3007 73.4793 59.2665 74.5307 59.9508 75.5919H129.366C130.858 74.1501 132.93 73.106 135.386 72.5547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.315 72.5156L143.634 72.5425C146.178 73.1597 147.874 74.3428 148.985 75.5894H164.069L163.315 72.5156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0451 72.706L15.5938 75.5871H38.0598C38.9334 74.3917 40.0497 73.411 41.5372 72.6719L16.0451 72.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5743 75.7136H20.4204L16.0257 72.8203L15.5743 75.7136Z",
    fill: "#D7504D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.708 70.0402C162.708 70.0402 156.964 69.3864 156.564 71.6624H163.106L162.708 70.0402Z",
    fill: "#D7504D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.068 64.9147C104.068 64.9147 104.548 65.91 105.919 66.6833C107.29 67.4591 109.006 71.8795 109.006 73.8189C109.006 75.7583 105.987 85.2188 105.987 85.2188H68.6601C68.6601 85.2188 66.396 75.7559 65.5709 70.2816C64.7459 64.8073 67.2041 63.1875 67.2041 63.1875",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2217_1998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteImage);
export default __webpack_public_path__ + "static/media/completeImage.ee55cf975926d1f84e770223d66aa988.svg";
export { ForwardRef as ReactComponent };